import request from '@/plugins/axios'
import systemConfig from '@/plugins/requireConfig/systemConfig.js'


// 根据字典类型查询字典数据信息
export function getListByDictType(dictType) {
    const data = {
        dictType:dictType
    }
    return request({
        url: `/${systemConfig.sysPrefix}/sys/dict/data/getListByDictType`,
        method: 'post',
        data
    })
}

// page
export function dataPage(data) {
    return request({
        url: `/${systemConfig.sysPrefix}/sys/dict/data/page`,
        method: 'post',
        data
    })
}

// list
export function dataList(data) {
    return request({
        url: `/${systemConfig.sysPrefix}/sys/dict/data/list`,
        method: 'post',
        data
    })
}

export function dataAdd(data) {
    return request({
        url: `/${systemConfig.sysPrefix}/sys/dict/data/add`,
        method: 'post',
        data
    })
}

export function dataUpdate(data) {
    return request({
        url: `/${systemConfig.sysPrefix}/sys/dict/data/update`,
        method: 'post',
        data
    })
}


export function dataDetail(id) {
    const data = {
        id:id
    }
    return request({
        url: `/${systemConfig.sysPrefix}/sys/dict/data/detail`,
        method: 'post',
        data
    })
}

export function dataDeleteForce(id) {
    const data = {
        id:id
    }
    return request({
        url: `/${systemConfig.sysPrefix}/sys/dict/data/deleteForce`,
        method: 'post',
        data
    })
}
